import { useNavigate } from 'react-router-dom';

import { Button } from '@components/index';

import { StepFooterConfig } from './types';

type StepFooterProps = NonNullable<StepFooterConfig>;

const StepFooter = ({
  continueLabel = 'Continue',
  backLabel = 'Back',
  onBackClick,
  onContinueClick,
  isContinueDisabled = false,
  isLoading = false
}: StepFooterProps) => {
  const navigate = useNavigate();
  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="w-full shrink-0 border-t border-cofeeGreyBlue4 shadow-[0_-4px_12px_-6px_rgba(16,24,40,0.12)]">
      <div className="flex justify-end gap-3 px-10 py-4">
        <Button
          label={backLabel}
          variant="tertiary"
          size="large"
          className="px-7"
          handleClick={handleBackClick}
        />
        <Button
          label={continueLabel}
          size="large"
          className="h-11 w-40"
          handleClick={onContinueClick}
          disabled={isContinueDisabled}
          loading={isLoading}
        />
      </div>
    </div>
  );
};

export default StepFooter;
